module.exports = __webpack_public_path__ + "img/connection-left-4.5bab45fe.png";